import { useEffect, useState } from 'react';
import axios from 'axios';
import sheetdb from 'sheetdb-node';
import 'animate.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { 
  Navbar, 
  NavItem, 
  NavbarToggler, 
  Collapse, 
  NavLink, 
  Nav, 
  NavbarBrand, 
  Button,
  Row,
  Container
 
} from 'reactstrap'; 
import Banner from './components/banner.js'
import Info from './components/info/Info.js';
import Instructor from './components/instructor/Instructor.js';
import Location from './components/Location/Location.js';
import Footer from './components/footer/footer.js';
import Loading from './components/loading.js';
import './App.css'


function App() {
  var config = {
    address: 'lmrht3p7ssu0r',
  };
  var client = sheetdb(config);
  const [ip, setIP] = useState("");

  const getData = async () => {
    const res = await axios.get("https://api.ipify.org/?format=json").then((result)=>{

    console.log(result)
      try{
        client.create({ 
          ipAddress: result.data.ip, 
          time: new Date(),
          page: "buildingPC"
        }, "views")
      }
      catch(ex){
        alert(ex.data)
      }
    });
  };
  useEffect(()=>{
    getData()
  },[])




  const [isOpen, setIsOpen] = useState(false)
  const [num, setNum] = useState(false)
  useEffect(()=>{
    document.getElementById('downArrow').classList.add('animate__shakeY')
    setTimeout(() => {
      document.getElementById('downArrow').classList.remove('animate__shakeY')
      setNum(!num)
    }, 10000);
   
  },[num])
  return (
    <div className="App">
      
      <Navbar expand="md" > 
                <NavbarBrand href="/"><span className='techUse'>HTX COMPUTER MARKET</span></NavbarBrand> 
                <NavbarToggler onClick={() => { setIsOpen(!isOpen) }} /> 
                <Collapse isOpen={isOpen} navbar> 
                    <Nav className="ms-auto" navbar> 
                        <NavItem> 
                            <Button color='success' style={window.innerWidth > 500 ? {marginRight:'20px'} : {marginTop:'10px'}} href="#instructor">Meet Your Instructor!</Button> 
                        </NavItem> 
                        <NavItem> 
                        <Button color='danger' style={window.innerWidth > 500 ? {marginRight:'20px'} : {marginTop:'10px'}} href="#location">Where is the workshop?</Button>
                        </NavItem>
                        <NavItem> 
                        <Button color='light' style={window.innerWidth > 500 ? {marginRight:'10px'} : {marginTop:'10px'}} href="#contact">Have questions? Contact Us!</Button>
                        </NavItem>
                    </Nav> 
                </Collapse> 
            </Navbar> 
      <Banner/>
      <Container>
      <Row className='text-center mt-5 ms-0'>
          <h1 id='downArrow' className='animate__animated'></h1>
      </Row>
      </Container>
      <Info/>
      <span id='instructor'>
      <Instructor/>
      </span>
      <span id='location'>
      <Location/>
      </span>
      <span id='contact'>
        <Footer/>
      </span>
    </div>
  );
}

export default App;
